import React from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "redux-form";

import { CustomDropdownByName } from "components";
import { ACHProcessorData } from "globalConstants";
import { AchProcessorTypes } from "types";

const AchProcessorDdl = ({
	isLoading,
	onChange,
}: {
	isLoading?: boolean;
	onChange?: Function;
}) => {
	const achProcessors = AchProcessorTypes.getOptions();

	const handleChange = () => {
		if (typeof onChange === "function") {
			onChange?.();
		}
	};

	return (
		<Row>
			<Col md={5}>
				<Field
					component={CustomDropdownByName}
					label={ACHProcessorData.ACHProcessor.displayName}
					name={ACHProcessorData.ACHProcessor.name}
					loading={isLoading}
					items={achProcessors}
					labelName="displayName"
					hideRequiredMark
					onChange={handleChange}
				/>
			</Col>
		</Row>
	);
};

export default AchProcessorDdl;
